import { render, staticRenderFns } from "./VDPCalculatorComponent.vue?vue&type=template&id=0fe1e07f"
import script from "./VDPCalculatorComponent.vue?vue&type=script&lang=js"
export * from "./VDPCalculatorComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports